/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Fulfillment,
    FulfillmentFromJSON,
    FulfillmentFromJSONTyped,
    FulfillmentToJSON,
} from './Fulfillment';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
} from './QueryInfo';

/**
 * 
 * @export
 * @interface GetFulfillmentsResponse
 */
export interface GetFulfillmentsResponse {
    /**
     * 
     * @type {Array<Fulfillment>}
     * @memberof GetFulfillmentsResponse
     */
    results: Array<Fulfillment>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof GetFulfillmentsResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof GetFulfillmentsResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof GetFulfillmentsResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof GetFulfillmentsResponse
     */
    hasPreviousPage?: boolean;
}

export function GetFulfillmentsResponseFromJSON(json: any): GetFulfillmentsResponse {
    return GetFulfillmentsResponseFromJSONTyped(json, false);
}

export function GetFulfillmentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFulfillmentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(FulfillmentFromJSON)),
        'listResult': QueryInfoFromJSON(json['listResult']),
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function GetFulfillmentsResponseToJSON(value?: GetFulfillmentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(FulfillmentToJSON)),
        'listResult': QueryInfoToJSON(value.listResult),
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}

